export const metricPickerFluentV2Style = {
  '.overview-card .metric-picker': {
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  '.overview-card .metric-picker__button--caret': {
    flex: '0 0 auto',
    minWidth: '0',
  },
  '.overview-card .metric-picker .dropdown-toggle': {
    border: 'none',
    height: 'auto',
    padding: '0 5px',
  },
  '.overview-card .metric-picker__name': {
    flex: '0 1 auto',
    whiteSpace: 'nowrap',
    minWidth: 1,
    maxWidth: 86,
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    fontSize: '14px',
  },
  '.overview-card .metric-picker__value': {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: 'flex',
    maxWidth: 86,

    '& .metric-value': {
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      flex: '0 1 auto',
      overflow: 'hidden',
      minWidth: 1,
      fontSize: '22px',
      fontWeight: '600',
      color: '#797775',
    },

    '& .metric-value-info': {
      marginLeft: '5px',
    },
  },
  '.overview-card .metric-picker__button': {
    border: 'none',
  },
  '.overview-card .metric-picker__button--single': {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    minWidth: 1,
    justifyContent: 'center',
  },
};
